// extracted by mini-css-extract-plugin
export var aircallIframe = "_hd-3";
export var fabContainer = "_hd-5";
export var fabRinging = "_hd-6";
export var loadingOverlay = "_hd-4";
export var pulse = "_hd-7";
export var widgetContent = "_hd-2";
export var widgetPanel = "_hd-0";
export var widgetPanelExpanded = "_hd-1";